module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "con",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rtit"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TITLE PAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rcop"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rded"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rint"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction"
    }
  }, [_vm._v("Introduction by "), _c('i', [_vm._v("Renée Watson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rpre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Preface"
    }
  }, [_vm._v("Preface by "), _c('i', [_vm._v("Ethel Johnston Phelps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mulha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hunter Maiden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elsa and the Evil Wizard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maria Morevna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Duffy and the Devil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lanval and the Lady Triamor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bending Willow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finn Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Woman and the Rice Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Husband Who Stayed at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scheherazade Retold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rbib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suggested Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rtea"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Teaser",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Series Teaser")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "raut"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE EDITOR and ILLUSTRATOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rals"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Also_by",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALSO BY FEMINIST PRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "ratp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Publisher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT FEMINIST PRESS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 66
// module chunks = 0